module.exports = __webpack_public_path__ + "static/media/i-minus-circle-white.09ddeef0.svg";